import { render, staticRenderFns } from "./linkman.vue?vue&type=template&id=788d9aa4&"
import script from "./linkman.vue?vue&type=script&lang=js&"
export * from "./linkman.vue?vue&type=script&lang=js&"
import style0 from "./linkman.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports